import { useState, type FormEvent } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../auth/AuthProvider'
import CartaoErro from '../componentes/CartaoErro'

// A frase de reserva fica na tela o tempo todo, nao so quando da erro: o
// servico de e-mail do plano gratis manda poucos por hora e e "melhor
// esforco". Quem nao receber precisa ler a saida sem ter de errar antes.
const RESERVA = 'Não chegou em alguns minutos? Olhe a caixa de spam — ou fale com quem te entregou o login.'

export default function EsqueciSenha() {
  const { pedirLinkDeNovaSenha } = useAuth()
  const [email, setEmail] = useState('')
  const [erro, setErro] = useState<string | null>(null)
  const [enviado, setEnviado] = useState(false)
  const [enviando, setEnviando] = useState(false)

  async function aoEnviar(e: FormEvent) {
    e.preventDefault()
    setEnviando(true)
    setErro(null)
    const mensagem = await pedirLinkDeNovaSenha(email)
    setEnviando(false)
    if (mensagem) setErro(mensagem)
    else setEnviado(true)
  }

  return (
    <main className="min-h-screen flex items-center justify-center bg-slate-100 p-4">
      <div className="w-full max-w-sm bg-white rounded-xl shadow-sm p-6 space-y-4">
        <h1 className="text-xl font-bold text-slate-800">Esqueci minha senha</h1>

        {enviado ? (
          <>
            {/* Neutra DE PROPOSITO: dizer "esse e-mail nao tem conta" faria
                desta tela um jeito de descobrir quem e cliente e quem nao e. */}
            <p className="text-sm text-slate-700" data-testid="link-enviado">
              Se existir uma conta com esse e-mail, o link já foi enviado. Ele vale por 1 hora.
            </p>
            <p className="text-sm text-slate-600">{RESERVA}</p>
            <Link to="/login" className="block text-center text-teal-700 underline text-sm">
              Voltar para o login
            </Link>
          </>
        ) : (
          <form onSubmit={aoEnviar} className="space-y-4">
            <p className="text-sm text-slate-600">
              Digite o e-mail da sua conta. Mandamos um link para você criar uma senha nova.
            </p>
            <div>
              <label htmlFor="email" className="block text-sm text-slate-600 mb-1">
                E-mail
              </label>
              <input
                id="email"
                type="email"
                required
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full border border-slate-300 rounded-lg px-3 py-2"
              />
            </div>
            {erro && <CartaoErro titulo="Não foi possível enviar o link">{erro}</CartaoErro>}
            <button
              type="submit"
              disabled={enviando}
              className="w-full bg-teal-700 text-white rounded-lg py-2 font-medium disabled:opacity-50"
            >
              {enviando ? 'Enviando…' : 'Enviar link'}
            </button>
            <p className="text-sm text-slate-500">{RESERVA}</p>
            <Link to="/login" className="block text-center text-teal-700 underline text-sm">
              Voltar para o login
            </Link>
          </form>
        )}
      </div>
    </main>
  )
}
